import {
  SectionElement,
  SectionRenderer,
  Theme,
  defineElement,
  globalOn,
  onClick,
  query,
  queryAll,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __commonJS,
  __decorateClass,
  __toESM
} from "./chunk-XDKWOSVF.js";

// node_modules/rematrix/dist/rematrix.js
var require_rematrix = __commonJS({
  "node_modules/rematrix/dist/rematrix.js"(exports, module) {
    (function(global, factory) {
      typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : factory(global.Rematrix = {});
    })(exports, function(exports2) {
      "use strict";
      function format(source) {
        if (source.constructor !== Array) {
          throw new TypeError("Expected array.");
        }
        if (source.length === 16) {
          return source;
        }
        if (source.length === 6) {
          var matrix = identity();
          matrix[0] = source[0];
          matrix[1] = source[1];
          matrix[4] = source[2];
          matrix[5] = source[3];
          matrix[12] = source[4];
          matrix[13] = source[5];
          return matrix;
        }
        throw new RangeError("Expected array with either 6 or 16 values.");
      }
      function identity() {
        var matrix = [];
        for (var i = 0; i < 16; i++) {
          i % 5 == 0 ? matrix.push(1) : matrix.push(0);
        }
        return matrix;
      }
      function inverse(source) {
        var m = format(source);
        var s0 = m[0] * m[5] - m[4] * m[1];
        var s1 = m[0] * m[6] - m[4] * m[2];
        var s2 = m[0] * m[7] - m[4] * m[3];
        var s3 = m[1] * m[6] - m[5] * m[2];
        var s4 = m[1] * m[7] - m[5] * m[3];
        var s5 = m[2] * m[7] - m[6] * m[3];
        var c5 = m[10] * m[15] - m[14] * m[11];
        var c4 = m[9] * m[15] - m[13] * m[11];
        var c3 = m[9] * m[14] - m[13] * m[10];
        var c2 = m[8] * m[15] - m[12] * m[11];
        var c1 = m[8] * m[14] - m[12] * m[10];
        var c0 = m[8] * m[13] - m[12] * m[9];
        var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
        if (isNaN(determinant) || determinant === Infinity) {
          throw new Error("Inverse determinant attempted to divide by zero.");
        }
        return [
          (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
          (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
          (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
          (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
          (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
          (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
          (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
          (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
          (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
          (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
          (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
          (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
          (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
          (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
          (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
          (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
        ];
      }
      function multiply(m, x) {
        var fm = format(m);
        var fx = format(x);
        var product = [];
        for (var i = 0; i < 4; i++) {
          var row = [fm[i], fm[i + 4], fm[i + 8], fm[i + 12]];
          for (var j = 0; j < 4; j++) {
            var k = j * 4;
            var col = [fx[k], fx[k + 1], fx[k + 2], fx[k + 3]];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
          }
        }
        return product;
      }
      function parse(source) {
        if (typeof source === "string") {
          var match = source.match(/matrix(3d)?\(([^)]+)\)/);
          if (match) {
            var raw = match[2].split(", ").map(function(value) {
              return parseFloat(value);
            });
            return format(raw);
          }
        }
        return identity();
      }
      function rotateX(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[5] = matrix[10] = Math.cos(theta);
        matrix[6] = matrix[9] = Math.sin(theta);
        matrix[9] *= -1;
        return matrix;
      }
      function rotateY(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[0] = matrix[10] = Math.cos(theta);
        matrix[2] = matrix[8] = Math.sin(theta);
        matrix[2] *= -1;
        return matrix;
      }
      function rotateZ(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[0] = matrix[5] = Math.cos(theta);
        matrix[1] = matrix[4] = Math.sin(theta);
        matrix[4] *= -1;
        return matrix;
      }
      function scale(scalar, scalarY) {
        var matrix = identity();
        matrix[0] = scalar;
        matrix[5] = scalarY || scalar;
        return matrix;
      }
      function scaleX(scalar) {
        var matrix = identity();
        matrix[0] = scalar;
        return matrix;
      }
      function scaleY(scalar) {
        var matrix = identity();
        matrix[5] = scalar;
        return matrix;
      }
      function scaleZ(scalar) {
        var matrix = identity();
        matrix[10] = scalar;
        return matrix;
      }
      function skew(angleX, angleY) {
        var thetaX = Math.PI / 180 * angleX;
        var matrix = identity();
        matrix[4] = Math.tan(thetaX);
        if (angleY) {
          var thetaY = Math.PI / 180 * angleY;
          matrix[1] = Math.tan(thetaY);
        }
        return matrix;
      }
      function skewX(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[4] = Math.tan(theta);
        return matrix;
      }
      function skewY(angle) {
        var theta = Math.PI / 180 * angle;
        var matrix = identity();
        matrix[1] = Math.tan(theta);
        return matrix;
      }
      function translate(distanceX, distanceY) {
        var matrix = identity();
        matrix[12] = distanceX;
        if (distanceY) {
          matrix[13] = distanceY;
        }
        return matrix;
      }
      function translateX(distance) {
        var matrix = identity();
        matrix[12] = distance;
        return matrix;
      }
      function translateY(distance) {
        var matrix = identity();
        matrix[13] = distance;
        return matrix;
      }
      function translateZ(distance) {
        var matrix = identity();
        matrix[14] = distance;
        return matrix;
      }
      exports2.format = format;
      exports2.identity = identity;
      exports2.inverse = inverse;
      exports2.multiply = multiply;
      exports2.parse = parse;
      exports2.rotateX = rotateX;
      exports2.rotateY = rotateY;
      exports2.rotateZ = rotateZ;
      exports2.scale = scale;
      exports2.scaleX = scaleX;
      exports2.scaleY = scaleY;
      exports2.scaleZ = scaleZ;
      exports2.skew = skew;
      exports2.skewX = skewX;
      exports2.skewY = skewY;
      exports2.translate = translate;
      exports2.translateX = translateX;
      exports2.translateY = translateY;
      exports2.translateZ = translateZ;
      Object.defineProperty(exports2, "__esModule", { value: true });
    });
  }
});

// node_modules/flipping/lib/constants.js
var require_constants = __commonJS({
  "node_modules/flipping/lib/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FOLLOW_ATTR = "data-flip-follow";
    exports.KEY_ATTR = "data-flip-key";
    exports.STATE_ATTR = "data-flip-state";
    exports.NO_DELTA = { top: 0, left: 0, width: 1, height: 1 };
  }
});

// node_modules/flipping/lib/utils.js
var require_utils = __commonJS({
  "node_modules/flipping/lib/utils.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Rematrix = require_rematrix();
    var constants_1 = require_constants();
    function mapValues(collection, iteratee) {
      var result = {};
      Object.keys(collection).forEach(function(key) {
        result[key] = iteratee(collection[key], key, collection);
      });
      return result;
    }
    exports.mapValues = mapValues;
    function mapTwoValues(a, b, iteratee) {
      var result = {};
      Object.keys(a || {}).forEach(function(key) {
        result[key] = iteratee(a[key], b[key], key);
      });
      return result;
    }
    exports.mapTwoValues = mapTwoValues;
    function matrixTranslate(x, y) {
      return Rematrix.translate(x, y).join(",");
    }
    exports.matrixTranslate = matrixTranslate;
    function matrixScale(x, y) {
      return Rematrix.scale(x, y).join(",");
    }
    exports.matrixScale = matrixScale;
    function matrixMultiply() {
      var matrices = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        matrices[_i] = arguments[_i];
      }
      return matrices.filter(function(a) {
        return !!a;
      }).reduce(Rematrix.multiply).join(",");
    }
    exports.matrixMultiply = matrixMultiply;
    function styleValue(prop, value) {
      if (["height", "width", "top", "left"].indexOf(prop) !== -1 && typeof value === "number") {
        return value + "px";
      }
      return value;
    }
    exports.styleValue = styleValue;
    function getStaggerDelay(index, stagger) {
      return typeof stagger === "function" ? stagger(index) : (stagger || 0) * index;
    }
    exports.getStaggerDelay = getStaggerDelay;
    exports.identity = function(a) {
      return a;
    };
    exports.noop = function() {
    };
    exports.rect = function(element) {
      var _a = element.getBoundingClientRect(), top = _a.top, left = _a.left, width = _a.width, height = _a.height;
      return {
        top,
        left,
        width,
        height,
        get transform() {
          return getComputedStyle(element).transform || void 0;
        }
      };
    };
    function isVisible(element) {
      var _a = exports.rect(element), width = _a.width, height = _a.height;
      return !(width === 0 && height === 0);
    }
    exports.isVisible = isVisible;
    function getDelta(a, b) {
      if (!a) {
        return constants_1.NO_DELTA;
      }
      if (!a.height) {
        return a;
      }
      if (!b.height) {
        return b;
      }
      return {
        top: a.top - b.top,
        left: a.left - b.left,
        width: a.width / b.width,
        height: a.height / b.height
      };
    }
    exports.getDelta = getDelta;
    exports.deltaChanged = function(delta) {
      return !!delta.top || !!delta.left || delta.width !== 1 || delta.height !== 1;
    };
    exports.boundsChanged = function(a, b) {
      return !!(a.top - b.top || a.left - b.left || a.width - b.width || a.height - b.height);
    };
    function mitt() {
      var all = {};
      var wild = [];
      return {
        /**
         * Register an event handler for the given type.
         *
         * @param  {String} type	Type of event to listen for, or `"*"` for all events
         * @param  {Function} handler Function to call in response to given event
         * @memberOf mitt
         */
        on: function(type, handler) {
          if (type === "*") {
            wild.push(handler);
          } else {
            (all[type] || (all[type] = [])).push(handler);
          }
        },
        /**
         * Remove an event handler for the given type.
         *
         * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
         * @param  {Function} handler Handler function to remove
         * @memberOf mitt
         */
        off: function(type, handler) {
          if (type === "*") {
            wild.splice(wild.indexOf(handler) >>> 0, 1);
          } else if (all[type]) {
            all[type].splice(all[type].indexOf(handler) >>> 0, 1);
          }
        },
        /**
         * Invoke all handlers for the given type.
         * If present, `"*"` handlers are invoked after type-matched handlers.
         *
         * @param {String} type  The event type to invoke
         * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
         * @memberOf mitt
         */
        emit: function(type, evt) {
          (all[type] || []).slice().map(function(handler) {
            handler(evt);
          });
          wild.slice().map(function(handler) {
            handler(type, evt);
          });
        }
      };
    }
    exports.mitt = mitt;
  }
});

// node_modules/flipping/lib/plugins/mirror.js
var require_mirror = __commonJS({
  "node_modules/flipping/lib/plugins/mirror.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    function mirrorPlugin(states, event) {
      if (event !== "flip") {
        return states;
      }
      var nextStates = {};
      Object.keys(states).forEach(function(key) {
        var state = states[key];
        var element = state.element || state.previous && state.previous.element;
        if (element) {
          if (element.hasAttribute("data-flip-follow")) {
            var followKey = element.getAttribute("data-flip-follow");
            if (followKey && states[followKey]) {
              nextStates[key] = __assign({}, state, { delta: __assign({ left: 0, top: 0 }, states[followKey].delta, { width: 1, height: 1 }) });
            } else if (state.type === "ENTER" || state.type === "LEAVE") {
              var candidateElement = element.nextElementSibling;
              while (candidateElement && (!candidateElement.hasAttribute("data-flip-key") || states[candidateElement.getAttribute("data-flip-key")].type !== "MOVE")) {
                candidateElement = candidateElement.nextElementSibling;
              }
              if (candidateElement) {
                var candidateDelta = states[candidateElement.getAttribute("data-flip-key")].delta;
                nextStates[key] = __assign({}, state, { delta: {
                  left: candidateDelta.left,
                  top: candidateDelta.top,
                  width: 1,
                  height: 1
                } });
              }
            }
          }
        }
      });
      return Object.assign(states, nextStates);
    }
    exports.default = mirrorPlugin;
  }
});

// node_modules/flipping/lib/plugins/radius.js
var require_radius = __commonJS({
  "node_modules/flipping/lib/plugins/radius.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function radiusPlugin(states, event) {
      if (event === "read") {
        Object.keys(states).forEach(function(key) {
          var state = states[key];
          var element = state.element;
          if (!element) {
            return;
          }
          state.data.radius = getComputedStyle ? getComputedStyle(element).borderRadius || "0" : "0";
        });
      }
      return states;
    }
    exports.default = radiusPlugin;
  }
});

// node_modules/flipping/lib/Flipping.js
var require_Flipping = __commonJS({
  "node_modules/flipping/lib/Flipping.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var utils_1 = require_utils();
    var constants_1 = require_constants();
    var mirror_1 = require_mirror();
    var radius_1 = require_radius();
    var active = function() {
      return true;
    };
    var identity = function(a) {
      return a;
    };
    var flipDatasetMap = {
      flipKey: ["key", identity],
      flipNoScale: ["noScale", function() {
        return true;
      }]
    };
    var getFlipData = function(element) {
      if (!("dataset" in element)) {
        return {};
      }
      var dataset = element.dataset;
      var data = {};
      Object.keys(dataset).forEach(function(key) {
        if (flipDatasetMap[key]) {
          var _a = flipDatasetMap[key], flipKey = _a[0], project = _a[1];
          data[flipKey] = project(dataset[key]);
        } else if (key.indexOf("flip") === 0) {
          data[key[4].toLowerCase() + key.slice(5)] = dataset[key];
        }
      });
      return data;
    };
    var createSelector = function(selector, attribute) {
      if (attribute === void 0) {
        attribute = constants_1.KEY_ATTR;
      }
      if (typeof selector === "string") {
        return function(parentElement) {
          var elements = parentElement.querySelectorAll(selector);
          var visibleElements = {};
          var result = [];
          elements.forEach(function(element) {
            if (!utils_1.isVisible(element)) {
              return;
            }
            var key = element.getAttribute(attribute);
            if (!key) {
              return;
            }
            visibleElements[key] = element;
            result.push(element);
          });
          return result;
        };
      }
      return selector;
    };
    var Flipping2 = (
      /** @class */
      function() {
        function Flipping3(options) {
          if (options === void 0) {
            options = {};
          }
          this.attribute = options.attribute || constants_1.KEY_ATTR;
          this.selector = createSelector(options.selector || "[" + this.attribute + "]", this.attribute);
          this.active = options.active || active;
          this.activeSelector = options.activeSelector || utils_1.isVisible;
          this.getBounds = options.getBounds || utils_1.rect;
          this.getDelta = options.getDelta || utils_1.getDelta;
          this.parentElement = options.parent || document.documentElement;
          this.plugins = options.plugins || [mirror_1.default, radius_1.default];
          this.emitter = utils_1.mitt();
          if (options.onRead) {
            this.on("read", options.onRead);
          }
          if (options.onFlip) {
            this.on("flip", options.onFlip);
          }
          if (options.onEnter) {
            this.on("enter", options.onEnter);
          }
          if (options.onLeave) {
            this.on("leave", options.onLeave);
          }
          this.states = {};
        }
        Flipping3.prototype.getRelativeBounds = function(parentBounds, childBounds) {
          return __assign({}, childBounds, { top: childBounds.top - parentBounds.top, left: childBounds.left - parentBounds.left });
        };
        Flipping3.prototype.selectActive = function(parentElement) {
          var _this = this;
          var elements = this.selector(parentElement);
          var activeElements = {};
          var result = [];
          elements.forEach(function(element) {
            if (!_this.activeSelector(element)) {
              return;
            }
            var key = element.getAttribute(_this.attribute);
            if (!key) {
              return;
            }
            activeElements[key] = element;
            result.push(element);
          });
          return result;
        };
        Flipping3.prototype.findParent = function(element, parent) {
          if (parent === void 0) {
            parent = this.parentElement;
          }
          var parentKey = element.getAttribute("data-flip-parent");
          var currentParent = element.parentElement;
          if (!parentKey) {
            while (currentParent && !currentParent.hasAttribute(this.attribute)) {
              currentParent = currentParent.parentElement;
            }
          } else {
            while (currentParent && currentParent.getAttribute(this.attribute) !== parentKey) {
              currentParent = currentParent.parentElement;
            }
          }
          return currentParent || parent;
        };
        Flipping3.prototype.dispatch = function(event, stateMap) {
          var finalStateMap = this.plugins.reduce(function(intermediateStateMap, plugin) {
            return plugin(intermediateStateMap, event);
          }, stateMap);
          this.emitter.emit(event, finalStateMap);
        };
        Flipping3.prototype.on = function(event, listener) {
          this.emitter.on(event, listener);
        };
        Flipping3.prototype.onFlip = function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          var key;
          var listener;
          if (args.length === 2) {
            key = args[0], listener = args[1];
          } else {
            listener = args[0];
          }
          this.emitter.on("flip", key ? function(stateMap) {
            var state = stateMap[key];
            if (state) {
              listener(state);
            }
          } : listener);
        };
        Flipping3.prototype.read = function(options) {
          if (options === void 0) {
            options = {};
          }
          this.flip(__assign({}, options, { readOnly: true }));
        };
        Flipping3.prototype.flip = function(options) {
          var _this = this;
          if (options === void 0) {
            options = {};
          }
          var parentElement = options.parent || this.parentElement;
          var elements = this.selectActive(parentElement);
          var fullState = {};
          elements.forEach(function(element, index) {
            var key = element.getAttribute(_this.attribute);
            if (!key) {
              return;
            }
            var data = getFlipData(element);
            var childParent = _this.findParent(element, parentElement);
            var childParentKey = childParent.getAttribute(_this.attribute);
            var childParentState = childParentKey ? fullState[childParentKey] : void 0;
            var parentBounds = _this.getBounds(childParent);
            var previous = _this.states[key];
            var isPresent = previous && previous.type !== "LEAVE";
            var bounds = _this.getRelativeBounds(parentBounds, _this.getBounds(element));
            var delta = isPresent && previous && previous.bounds ? _this.getDelta(previous.bounds, bounds) : void 0;
            var newState = {
              type: isPresent ? "MOVE" : "ENTER",
              key,
              element,
              bounds,
              delta,
              start: Date.now(),
              animation: isPresent ? previous.animation : void 0,
              index,
              previous: previous ? {
                type: previous.type,
                bounds: previous.bounds,
                animation: previous.animation,
                element: previous.element,
                data: previous.data
              } : void 0,
              parent: childParentState,
              data
            };
            _this.states[key] = fullState[key] = newState;
          });
          if (options.readOnly) {
            return this.dispatch("read", fullState);
          }
          Object.keys(this.states).forEach(function(key, index) {
            if (fullState[key]) {
              return;
            }
            var prevState = _this.states[key];
            _this.states[key] = fullState[key] = {
              type: "LEAVE",
              key,
              element: void 0,
              bounds: void 0,
              start: Date.now(),
              animation: void 0,
              delta: void 0,
              index,
              parent: void 0,
              previous: {
                type: prevState.type,
                bounds: prevState.bounds,
                animation: prevState.animation,
                element: prevState.element
              }
            };
          });
          return this.dispatch("flip", fullState);
        };
        Flipping3.prototype.setAnimation = function(key, animation) {
          this.states[key].animation = animation;
        };
        Flipping3.prototype.wrap = function(fn, options) {
          var _this = this;
          if (options === void 0) {
            options = {};
          }
          return function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            _this.read(options);
            var result = fn.apply(null, args);
            _this.flip(options);
            return result;
          };
        };
        Flipping3.prototype.progress = function(key, fraction) {
          var delta = this.states[key].delta;
          if (!delta) {
            return;
          }
          return Flipping3.progress(delta, fraction);
        };
        Flipping3.progress = function(delta, fraction) {
          if (!delta) {
            return constants_1.NO_DELTA;
          }
          var invFraction = 1 - fraction;
          return {
            top: delta.top * invFraction,
            left: delta.left * invFraction,
            width: delta.width * invFraction,
            height: delta.height * invFraction
          };
        };
        Flipping3.rect = utils_1.rect;
        Flipping3.willScale = function(state) {
          return !!(state && state.element && !state.element.hasAttribute("data-noflip") && state.delta && (state.delta.width !== 1 || state.delta.height !== 1));
        };
        Flipping3.willMove = function(state) {
          if (!state || !state.delta) {
            return false;
          }
          return state && (state.delta.top !== 0 || state.delta.left !== 0);
        };
        return Flipping3;
      }()
    );
    exports.default = Flipping2;
  }
});

// node_modules/flipping/lib/animations.js
var require_animations = __commonJS({
  "node_modules/flipping/lib/animations.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var utils_1 = require_utils();
    var Rematrix = require_rematrix();
    exports.scale = function(state) {
      var bounds = state.bounds, delta = state.delta, element = state.element;
      if (!element || !delta || !bounds) {
        return void 0;
      }
      var scaleChanged = !state.data.noScale && (delta.width !== 1 || delta.height !== 1);
      var translate = Rematrix.translate(delta.left, delta.top);
      var scale = scaleChanged ? Rematrix.scale(delta.width, delta.height) : void 0;
      var transformOrigin = scaleChanged ? "top left" : void 0;
      var invertedMatrix = utils_1.matrixMultiply(
        // Rematrix.parse(bounds.transform),
        translate,
        scale
      );
      var elementPosition = {
        from: __assign({ x: delta.left, y: delta.top }, transformOrigin ? { transformOrigin } : void 0, { transform: "matrix3d(" + invertedMatrix + ")" }),
        to: __assign({ x: bounds.left, y: bounds.top }, transformOrigin ? { transformOrigin } : void 0, { transform: bounds.transform || "none" })
      };
      return {
        element: elementPosition
      };
    };
    exports.slide = function(state) {
      var delta = state.delta, previous = state.previous, bounds = state.bounds;
      if (!previous || !previous.bounds || !bounds) {
        return;
      }
      var height = Math.max(previous.bounds.height, bounds.height);
      var width = Math.max(previous.bounds.width, bounds.width);
      var elementPosition = {
        from: {
          height,
          width,
          transformOrigin: "top left"
        },
        to: {
          height,
          width,
          transformOrigin: "top left"
        }
      };
      var containerPosition = {
        from: {
          height,
          width,
          transformOrigin: "top left"
        },
        to: {
          height,
          width,
          transformOrigin: "top left"
        }
      };
      var deltaWidth = bounds.width - previous.bounds.width;
      var deltaHeight = bounds.height - previous.bounds.height;
      if (!delta) {
        return;
      }
      if (deltaWidth > 0) {
        containerPosition.from.x = -deltaWidth + delta.left;
        containerPosition.to.x = 0;
        elementPosition.from.x = deltaWidth;
        elementPosition.to.x = 0;
      } else {
        containerPosition.from.x = 0;
        containerPosition.to.x = deltaWidth - delta.left;
        elementPosition.from.x = 0;
        elementPosition.to.x = -deltaWidth;
      }
      if (deltaHeight > 0) {
        containerPosition.from.y = -deltaHeight + delta.top;
        containerPosition.to.y = 0;
        elementPosition.from.y = deltaHeight;
        elementPosition.to.y = 0;
      } else {
        containerPosition.from.y = 0;
        containerPosition.to.y = deltaHeight - delta.top;
        elementPosition.from.y = 0;
        elementPosition.to.y = -deltaHeight;
      }
      var elementFrom = utils_1.matrixTranslate(elementPosition.from.x, elementPosition.from.y);
      var elementTo = utils_1.matrixTranslate(elementPosition.to.x, elementPosition.to.y);
      var containerFrom = utils_1.matrixTranslate(containerPosition.from.x, containerPosition.from.y);
      var containerTo = utils_1.matrixTranslate(containerPosition.to.x, containerPosition.to.y);
      elementPosition.from.transform = "matrix3d(" + elementFrom + ")";
      elementPosition.to.transform = "matrix3d(" + elementTo + ")";
      containerPosition.from.transform = "matrix3d(" + containerFrom + ")";
      containerPosition.to.transform = "matrix3d(" + containerTo + ")";
      return {
        element: elementPosition,
        container: containerPosition
      };
    };
  }
});

// node_modules/flipping/lib/adapters/web.js
var require_web = __commonJS({
  "node_modules/flipping/lib/adapters/web.js"(exports, module) {
    "use strict";
    var __extends = exports && exports.__extends || function() {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
        d.__proto__ = b;
      } || function(d, b) {
        for (var p in b)
          if (b.hasOwnProperty(p))
            d[p] = b[p];
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    var __assign = exports && exports.__assign || Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    var Flipping_1 = require_Flipping();
    var animations = require_animations();
    var utils_1 = require_utils();
    var STATE_ATTR = "data-flip-state";
    function animate(strategy, elementMap, options) {
      var elementAnimations = utils_1.mapValues(elementMap, function(element, key) {
        requestAnimationFrame(function() {
          return element.setAttribute(STATE_ATTR, "active");
        });
        var animation = element.animate([
          utils_1.mapValues(strategy[key].from, function(value, prop) {
            return utils_1.styleValue(prop, value);
          }),
          utils_1.mapValues(strategy[key].to, function(value, prop) {
            return utils_1.styleValue(prop, value);
          })
        ], options);
        animation.onfinish = function() {
          element.setAttribute(STATE_ATTR, "complete");
        };
        return animation;
      });
      return {
        finish: function() {
          utils_1.mapValues(elementAnimations, function(elementAnimation) {
            elementAnimation.finish();
          });
        }
      };
    }
    var slidingLayersAnimation = function(state, options) {
      var element = state.element;
      var mode = animations.slide(state);
      if (!mode || !element || !element.parentElement) {
        return;
      }
      return animate(mode, {
        element,
        container: element.parentElement
      }, options);
    };
    var scaleAnimation = function(state, options) {
      if (options === void 0) {
        options = {};
      }
      var element = state.element;
      var mode = animations.scale(state);
      if (!mode || !element) {
        return;
      }
      return animate(mode, { element }, options);
    };
    var autoAnimation = function(state, options) {
      var element = state.element, delta = state.delta;
      var timingOptions = __assign({}, options, { delay: +(options.delay || 0) + utils_1.getStaggerDelay(state.index, options.stagger || 0), fill: options.stagger ? "both" : "none" });
      if (!element) {
        return;
      }
      if (!delta || !utils_1.deltaChanged(delta)) {
        return;
      }
      return scaleAnimation(state, timingOptions);
    };
    function waapiOnRead(stateMap) {
      Object.keys(stateMap).forEach(function(key) {
        var animation = stateMap[key].animation;
        if (animation && animation.finish) {
          animation.finish();
        }
      });
    }
    var FlippingWeb = (
      /** @class */
      function(_super) {
        __extends(FlippingWeb2, _super);
        function FlippingWeb2(options) {
          if (options === void 0) {
            options = {};
          }
          var _this = this;
          var optionsWithDefaults = __assign({}, FlippingWeb2.defaults, options);
          _this = _super.call(this, __assign({ onRead: waapiOnRead, onFlip: function(stateMap) {
            Object.keys(stateMap).forEach(function(key) {
              var animation = FlippingWeb2.animate.auto(stateMap[key], optionsWithDefaults);
              _this.setAnimation(key, animation);
            });
          } }, optionsWithDefaults)) || this;
          return _this;
        }
        FlippingWeb2.defaults = {
          duration: 300,
          delay: 0,
          easing: "cubic-bezier(.5, 0, .5, 1)",
          fill: "none",
          stagger: 0
        };
        FlippingWeb2.animate = {
          auto: autoAnimation,
          transform: scaleAnimation,
          slidingLayers: slidingLayersAnimation
        };
        return FlippingWeb2;
      }(Flipping_1.default)
    );
    module.exports = FlippingWeb;
  }
});

// src/sections/common-cart-drawer/common-cart-drawer.ts
var import_web = __toESM(require_web());
var CommonCartDrawer = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
    this.flipping = new import_web.default({ parent: this, duration: 1e3, easing: "ease" });
  }
  connectedCallback() {
    Theme.Cart.on("updated", () => __async(this, null, function* () {
      yield this.renderAjaxCart();
    }));
    window.addEventListener("popstate", (event) => {
      if (this.isOpen) {
        this.close();
      }
    });
  }
  renderAjaxCart() {
    return __async(this, null, function* () {
      const [html, cartTotal] = yield Promise.all([SectionRenderer.renderSection("ajax-cart"), SectionRenderer.renderSection("ajax-cart-total")]);
      this.flipping.read();
      this.lineItemsWrapper.innerHTML = html;
      this.cartTotalElm.innerHTML = cartTotal;
      this.flipping.flip();
      if (this.commonLineItems !== void 0 && this.commonLineItems.length > 0) {
        this.emptyCartText.classList.add("hidden");
        this.emptyCartText.classList.remove("flex");
        this.emptyShippingBar.classList.remove("hidden");
        this.emptyCheckoutBox.classList.remove("hidden");
      } else {
        this.emptyCartText.classList.remove("hidden");
        this.emptyCartText.classList.add("flex");
        this.emptyShippingBar.classList.add("hidden");
        this.emptyCheckoutBox.classList.add("hidden");
      }
    });
  }
  open() {
    return __async(this, null, function* () {
      if (!this.isOpen) {
        window.history.pushState("cart", "", "#cart");
      }
      this.isOpen = true;
      this.classList.add("block");
      this.classList.remove("hidden");
      yield wait(5);
      this.backdrop.classList.add("opacity-100");
      this.backdrop.classList.remove("opacity-0");
      this.drawer.classList.add("translate-x-0");
      this.drawer.classList.remove("translate-x-[calc(100%+5rem)]");
      if (this.commonLineItems !== void 0 && this.commonLineItems.length > 0) {
        this.emptyCartText.classList.add("hidden");
        this.emptyCartText.classList.remove("flex");
        this.emptyShippingBar.classList.remove("hidden");
        this.emptyCheckoutBox.classList.remove("hidden");
      } else {
        this.emptyCartText.classList.remove("hidden");
        this.emptyCartText.classList.add("flex");
        this.emptyShippingBar.classList.add("hidden");
        this.emptyCheckoutBox.classList.add("hidden");
      }
    });
  }
  close() {
    return __async(this, null, function* () {
      this.isOpen = false;
      this.backdrop.classList.add("opacity-0");
      this.backdrop.classList.remove("opacity-100");
      this.drawer.classList.add("translate-x-[calc(100%+5rem)]");
      this.drawer.classList.remove("translate-x-0");
      yield wait(700);
      if (!this.isOpen) {
        this.classList.add("hidden");
        this.classList.remove("block");
      }
    });
  }
  startLoading() {
    this.checkoutBtn.setAttribute("loading", "");
  }
  stopLoading() {
    this.checkoutBtn.removeAttribute("loading");
  }
};
__decorateClass([
  query("[data-backdrop]")
], CommonCartDrawer.prototype, "backdrop", 2);
__decorateClass([
  query("[data-drawer]")
], CommonCartDrawer.prototype, "drawer", 2);
__decorateClass([
  query("[data-line-items]")
], CommonCartDrawer.prototype, "lineItemsWrapper", 2);
__decorateClass([
  query("[data-cart-total]")
], CommonCartDrawer.prototype, "cartTotalElm", 2);
__decorateClass([
  query("[data-checkout]")
], CommonCartDrawer.prototype, "checkoutBtn", 2);
__decorateClass([
  query("[data-empty-cart]")
], CommonCartDrawer.prototype, "emptyCartText", 2);
__decorateClass([
  query("[data-shipping-bar]")
], CommonCartDrawer.prototype, "emptyShippingBar", 2);
__decorateClass([
  query("[data-checkout-info-box]")
], CommonCartDrawer.prototype, "emptyCheckoutBox", 2);
__decorateClass([
  queryAll("common-line-item")
], CommonCartDrawer.prototype, "commonLineItems", 2);
__decorateClass([
  globalOn("cart:updated")
], CommonCartDrawer.prototype, "renderAjaxCart", 1);
__decorateClass([
  globalOn("cart:open")
], CommonCartDrawer.prototype, "open", 1);
__decorateClass([
  globalOn("cart:close"),
  onClick("[data-close], [data-backdrop]")
], CommonCartDrawer.prototype, "close", 1);
__decorateClass([
  onClick("[data-checkout]"),
  globalOn("cart:startLoading")
], CommonCartDrawer.prototype, "startLoading", 1);
__decorateClass([
  globalOn("cart:stopLoading")
], CommonCartDrawer.prototype, "stopLoading", 1);
CommonCartDrawer = __decorateClass([
  defineElement("common-cart-drawer")
], CommonCartDrawer);
export {
  CommonCartDrawer
};
/*! Bundled license information:

rematrix/dist/rematrix.js:
  (*  @license Rematrix v0.1.3
  
      Copyright (c) 2017 Fisssion LLC
  
      Permission is hereby granted, free of charge, to any person obtaining a copy
      of this software and associated documentation files (the "Software"), to deal
      in the Software without restriction, including without limitation the rights
      to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      copies of the Software, and to permit persons to whom the Software is
      furnished to do so, subject to the following conditions:
  
      The above copyright notice and this permission notice shall be included in
      all copies or substantial portions of the Software.
  
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      THE SOFTWARE.
  *)
*/
